var pageId = '';

pageId = document.querySelector('body').getAttribute('id');
switch (pageId) {
  //body id='top'
  case 'top':
    require('./top.ts');
    break;
  //body id='development'
  case 'development':
    require('../../development/js/development.ts');
    break;
  //body id='access'
  case 'access':
    require('../../access/js/access.ts');
    break;
  //body id='design'
  case 'design':
    require('../../design/js/design.ts');
    break;
  //body id='property'
  case 'property':
    require('../../property/js/property.ts');
    break;
  //body id='renace'
  case 'renace':
    require('../../renace/js/renace.ts');
    break;
  //body id='quality'
  case 'quality':
    require('../../quality/js/quality.ts');
    break;

  //body id='map'
  case 'outline':
    window.addEventListener('DOMContentLoaded', function () {
      const todayElm = document.querySelectorAll('.js-todayElm');
      const nextElm = document.querySelectorAll('.js-nextElm');
      const upToday = new Date();
      const upNext = new Date();
      upNext.setDate(upToday.getDate() + 14)

      const todayM = upToday.getMonth() + 1;
      const nextM = upNext.getMonth() + 1;
      for (let i = 0; i < todayElm.length; i++) {
        todayElm[i].innerHTML = upToday.getFullYear() + "年" + todayM + "月" + upToday.getDate() + "日";
      }
      for (let i = 0; i < nextElm.length; i++) {
        nextElm[i].innerHTML = upNext.getFullYear() + "年" + nextM + "月" + upNext.getDate() + "日";
      }
    });
    break;
};
//common
require('./anime.ts');


const header = document.querySelector('header');
window.addEventListener('scroll', function () {
  var sH = window.scrollY;
  if (sH >= 100) {
    header.classList.add('hScroll');
  } else {
    header.classList.remove('hScroll');
  }
});

const gBtn = document.querySelector('.g_menu_btn');
const gNav = document.querySelector('.g_nav');
const pcLogo = document.querySelector('.hd-logo_area');
gBtn.addEventListener('click', function () {
  this.classList.toggle('active');
  gNav.classList.toggle('active');
  pcLogo?.classList.toggle('hide');
});

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++) {
  smoothScrollTrigger[i].addEventListener('click', (event) => {
    event.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.scrollY;
    const gap = 0;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}


//mapモーダル表示
// document.querySelectorAll(".map_modal").forEach(function (el) {
//   el.addEventListener("click", function (e) {
//     e.preventDefault();
//     const modal = document.getElementById("mapModal");
//     modal.style.display = "block";
//     // 少し遅延してクラス追加 → アニメーションを発火させる
//     setTimeout(() => modal.classList.add("show"), 10);
//     initMap();
//   });
// });

// document.querySelector(".closeBtn").addEventListener("click", function () {
//   const modal = document.getElementById("mapModal");
//   modal.classList.remove("show");
//   setTimeout(() => modal.style.display = "none", 300); // アニメ後に非表示
// });



const nav = document.querySelector('.bottom_header');

function updateNavPosition() {
  const vh = window.innerHeight;
  const navHeight = nav.offsetHeight;
  nav.style.top = `${vh - navHeight}px`; // ← bottom: 0 の代わり！
}

window.addEventListener('resize', () => {
  setTimeout(updateNavPosition, 100); // ← 遅延でアドレスバーの変化に追従しやすく
});

updateNavPosition();

/* ハンバーガーメニュー内のスクロール*/
const menu = document.querySelector('.nav_area');
let scrollHeight;

gBtn?.addEventListener('click', function () {
  if (gBtn?.classList.contains('active')) {
    scrollHeight = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollHeight}px`;
  } else {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollHeight);
  }
});

if (menu) {
  // マウスホイールでのスクロール
  menu.addEventListener('wheel', function (e) {
    const delta = e.deltaY;
    const currentScrollTop = this.scrollTop;
    const maxScrollTop = this.scrollHeight - this.clientHeight;

    if (maxScrollTop > 0) {
      if (
        (delta < 0 && currentScrollTop > 0) ||
        (delta > 0 && currentScrollTop < maxScrollTop)
      ) {
        e.preventDefault();
        e.stopPropagation();
        this.scrollTop += delta; // ← 内側をスクロール
      }
    }
  }, { passive: false });

  // タッチ操作でのスクロール
  let startY = 0;
  let startScrollTop = 0;

  menu.addEventListener('touchstart', function (e) {
    startY = e.touches[0].pageY;
    startScrollTop = this.scrollTop;
  }, { passive: true });

  menu.addEventListener('touchmove', function (e) {
    const currentY = e.touches[0].pageY;
    const diffY = startY - currentY;
    const newScrollTop = startScrollTop + diffY;
    const maxScrollTop = this.scrollHeight - this.clientHeight;

    if (maxScrollTop > 0) {
      if (newScrollTop >= 0 && newScrollTop <= maxScrollTop) {
        e.preventDefault();
        e.stopPropagation();
        this.scrollTop = newScrollTop; // ← 指で動かした分だけスクロール
      }
    }
  }, { passive: false });
}